import color from "./colors";

export default {
  disabled: color.gray["04"],
};
